import * as React from 'react';
import { useState, useEffect } from 'react';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, UncontrolledDropdownProps } from 'reactstrap';

type ItemID = any;

export type GenericDropdownProps<T> = {
    dataSource: T[];
    renderItem: (item: T) => React.ReactNode;
    renderSelectedItem: (item: T) => React.ReactNode;
    onSelectedItemChanged?: (selectedItem: T) => void;
    getId: (item: T) => ItemID;    
    selectedValue?: ItemID | undefined;
    allowNullSelection?: boolean;
    nullSelectionText?: string;
    className?: string;
    onBlur?: (event: React.FocusEvent<HTMLElement>) => void;    
    rootCtrlProps?: React.HTMLAttributes<HTMLElement>;
    dropdownMenuProps?: React.HTMLAttributes<HTMLElement>;
}

export default function GenericDropdown<T>(props: GenericDropdownProps<T>) {

    let itemByValue = (props.selectedValue != undefined)
        ? props.dataSource.find(x => props.selectedValue == props.getId(x))
        : undefined;

    const [selectedItem, setSelectedItem] = useState(itemByValue)

    useEffect(() => {

        if (props.selectedValue != undefined) {
            var itemByValue = props.dataSource.find(x => props.selectedValue == props.getId(x));
            setSelectedItem(itemByValue);

        } else {            
            setSelectedItem(undefined);
        }

    }, [props.selectedValue, props.dataSource])       

    return (<React.Fragment>
        <UncontrolledDropdown className={props.className} onBlur={props.onBlur} {...props.rootCtrlProps}>
            <DropdownToggle className="w-100 d-flex border" color="light">
                <span className="w-100 text-left">{selectedItem && props.renderSelectedItem(selectedItem)}
                    {!selectedItem && (props.nullSelectionText || 'Select')}
                </span>
                <i className="flex-shrink-1 align-self-center fa fa-angle-down"></i>
            </DropdownToggle>
            {
                props.dataSource != null && props.dataSource.length > 0
                    ? <DropdownMenu {...props.dropdownMenuProps}>
                        <div className="dropdown-menu-inner">                            
                            {props.allowNullSelection === true && 
                                <DropdownItem key="null-selection" onClick={x => {
                                    props.onSelectedItemChanged && props.onSelectedItemChanged(undefined);
                                    setSelectedItem(undefined);
                                }} className="clear-selection">
                                    {props.nullSelectionText || "Select"}
                                </DropdownItem>
                            }
                            {props.dataSource.map(
                                (item: T) => <DropdownItem key={props.getId(item).toString()} onClick={x => {                                                                
                                    if (props.onSelectedItemChanged)
                                        props.onSelectedItemChanged(item);
                                    else
                                        setSelectedItem(item);
                                }}>
                                    {props.renderItem(item)}
                                </DropdownItem>)}
                            </div>
                    </DropdownMenu>
                    : null
            }
        </UncontrolledDropdown>
    </React.Fragment>);
}

